// For our resizing logic, we decided to fix the game height at 1024px and resize the width based on the device aspect ratio
let HEIGHT = 1024;
let WIDTH = (window.innerWidth / window.innerHeight) * HEIGHT;
WIDTH = WIDTH > 768 ? 768 : WIDTH; // cap the width

// let DEVICE_PIXEL_RATIO = window.devicePixelRatio > 1 ? 2 : 1;
let DEVICE_PIXEL_RATIO = 1;

let RESOLUTION = DEVICE_PIXEL_RATIO > 1 ? '2x' : '1x';
// console.log('RESOLUTION', RESOLUTION);

const BLUE = 'blue';
const GREEN = 'green';
const PINK = 'pink';
const PURPLE = 'purple';
let GIRLS = {};
GIRLS[BLUE] = 'bubbles';
GIRLS[GREEN] = 'buttercup';
GIRLS[PINK] = 'blossom';
GIRLS[PURPLE] = 'bliss';
const config = {
  DATA_HTP_COMPLETE: 'DATA_HTP_COMPLTE',
  PURPLE: PURPLE,
  MUSIC_ON: 'musicOn',
  SOUNDS_ON: 'soundsOn',
  MEDIA_IMAGE_PATH: './media/images/',
  MEDIA_AUDIO_PATH: './media/audio/',
  DEBUG_CHILDREN: 'CHILDREN',
  DEBUG_ADVERTISEMENT: 'DEBUG_ADVERTISEMENT',
  LOCAL_STORAGE_KEY: 'ben-ten',
  DEVICE_PIXEL_RATIO: DEVICE_PIXEL_RATIO,
  RESOLUTION: RESOLUTION,
  SCALE: DEVICE_PIXEL_RATIO > 1 ? 0.5 : 1,
  WIDTH: WIDTH,
  HEIGHT: HEIGHT,
  THIRD_WIDTH: WIDTH / 3,
  CENTER_X: WIDTH / 2,
  CENTER_Y: HEIGHT / 2,
  ASPECT_RATIO: WIDTH / HEIGHT,
  BASE_SCENE: 'BASE_SCENE',
  PLAY_HTP_COMPLETE: false,
  PLAY_COUNT: 'PLAY_COUNT',
  PLAY_STATE: 'PLAY_STATE',
  PLAY_STATE_INTRO: 'PLAY_STATE_INTRO',
  PLAY_STATE_ACTIVE: 'PLAY_STATE_ACTIVE',
  PLAY_STATE_SPECIAL: 'PLAY_STATE_SPECIAL',
  PLAY_STATE_OUTRO: 'PLAY_STATE_OUTRO',
  GIRLS: GIRLS,
  ROUND: 10000,
  BLUE: BLUE,
  GREEN: GREEN,
  PINK: PINK,
  COLORS: [ BLUE, GREEN, PINK ],
  COLOR_OFFSETS: [0, 120, 240],
  COLOR_RADIUS: 38,
  ROTATE_RADIUS: 70,
  ROTATE: 120,
  ROTATE_EASE: 4,
  ROTATE_CENTER: [ WIDTH / 2, HEIGHT - 100 ],
  ROTATE_CENTER_OFFSCREEN: [ WIDTH / 2, HEIGHT + 164 ],
  START_ROTATION: -90,
  RAINBOW_RECT: 50,
  RAINBOW_RADIUS: 25,
  RAINBOW_SPAWN_Y: -200,
  WAVE_SPEED: 3,
  WAVE_SPEED_INCREASE: 0.5,
  WAVE_SPEED_MAX: 10,
  WAVE_FRAMES_TO_TOP_SPEED: 600,
  WAVE_SPAWN_THRESHOLD_MIN: 200,
  WAVE_SPAWN_THRESHOLD_MAX: 500,
  WAVE_RAINBOW_COUNT: 5,
  WAVE_RAINBOW_COUNT_INCREASE: 1,
  METER_FILL_TOTAL: 100,
  METER_RAINBOW_FILL: 5,
  // METER_RAINBOW_FILL: 25, // for fast special in dev only
  METER_RAINBOW_FILL_MIN: 1,
  METER_RAINBOW_FILL_DECREASE: 0.5,
  METER_RAINBOW_DRAIN: 25,
  SPECIAL_START_EASE_TIME: 1000,
  SPECIAL_SPEED_EASE_IN: 30,
  SPECIAL_SPEED_EASE_OUT: 10,
  SPECIAL_WAVE_RAINDOW_COUNT: 15,
  SPECIAL_WAVE_SPEED: 20,
  POINTS_PER_RAINBOW: 10,
  POINTS_PER_WAVE: 100,
  TEXT_HTP: 'Tap to rotate the Powerpuff Girls.\n Match their colors to destroy \nAllegro\'s rainbow attacks!',
  TEXT_TAP_START: 'Tap to Start',
  TEXT_READY: 'Get Ready',
  TEXT_CONTINUE_TITLE: [
    'Game Over',
    'Game Over',
    'Game Over'
  ],
  TEXT_CONTINUE_BODY: [
    'Watch an ad to revive up to 3 times!\n(plus, get a free Bliss power-up!)',
    'Revive again by watching an ad!\n(Only 2 continues left!)',
    'Watch an ad to revive 1 last time!\n(Make this a good one!)'
  ],
  AD_TYPE_POWERUP: 'AD_TYPE_POWERUP',
  AD_TYPE_CONTINUE: 'CONTINUE',
  AD_CONTINUE_COUNT: 3
};

export default config;
